import {
  GetComisionesManualExtras,
  DeleteComisionManual,
  State as ComisionManualState
} from "../../../reducers/comisionManual";

export interface ComisionesManualesAdminStore
  extends GetComisionesManualExtras,
    DeleteComisionManual {}

export const comisionesManualesAdminStore: (
  state
) => ComisionesManualesAdminStore = state => {
  const comisionManual: ComisionManualState = state.comisionManual;

  return {
    comisionesManualExtras: comisionManual.comisionesManualExtras,
    gettingComisionesManualExtras: comisionManual.gettingComisionesManualExtras,
    gettingComisionesManualExtrasError:
      comisionManual.gettingComisionesManualExtrasError,
    deletingComisionManual: comisionManual.deletingComisionManual,
    deletingComisionManualError: comisionManual.deletingComisionManualError
  };
};
